import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Instructions.css';

const Instructions = () => {
    const navigate = useNavigate();
    const [isChecked, setIsChecked] = useState(false);
    const testName = sessionStorage.getItem("test_name") || "Economy - Sectional Test 1";

    return (
        <div className="instructions-container">
            <div className="instructions-header">
                <img src="/assets/images/logo/SVG/Logo-Org.svg" alt="Yooki" className="yooki-logo" />
                <span className="separator">|</span>
                <span className="exam-title-header">{testName}</span>
            </div>

            <div className="instructions-content">
                <h1 className="exam-main-title">{testName}</h1>

                <div className="instructions-card">
                    <h2 className="instructions-title">Instructions :</h2>

                    <ul className="instructions-list">
                        <li>After you select the correct option for the question, click on Next. This is mandatory for submitting your answer.</li>
                        <li>If you happen to choose the option and move to the next question from the Question Palette on the right, the answer will not be submitted. Such questions will be considered as not answered and marked in red.</li>
                        <li>The questions which are not attempted at all are also marked in red.</li>
                        <li>Question Palette will show you questions answered, not answered, marked, not visited, answered & marked for review.</li>
                        <li>After you finish answering your question, it is mandatory to click on Submit, else the test remains in an unfinished state and the reporting will not be accurate.</li>
                        <li>After finishing the test, you'll be able to see your scores and solutions to the questions</li>
                    </ul>

                    <div className="checkbox-container">
                        <input
                            type="checkbox"
                            id="understand-checkbox"
                            checked={isChecked}
                            onChange={(e) => setIsChecked(e.target.checked)}
                        />
                        <label htmlFor="understand-checkbox">I understand, and I am ready to begin</label>
                    </div>
                </div>

                <div className="action-buttons">
                    <button className="cancel-btn" onClick={() => navigate(-1)}>Cancel Exam</button>
                    <button className="start-btn" disabled={!isChecked} onClick={() => navigate('/test/active')}>Start Exam</button>
                </div>
            </div>
        </div>
    );
};

export default Instructions;
